import { CardMI } from '@atmi/models/cards/card-mi';
import { createStore } from '@ngneat/elf';
import {
  addEntities,
  deleteEntities,
  selectAllEntities,
  setEntities,
  updateEntities,
  withEntities
} from '@ngneat/elf-entities';

export const store = createStore({ name: 'beneMI' }, withEntities<CardMI>());

export const beneMI$ = store.pipe(selectAllEntities());

export function setAllMI(cards: CardMI[]) {
  store.update(setEntities(cards));
}

export function addMI(card: CardMI) {
  store.update(addEntities(card));
}

export function updateMI(id: CardMI['id'], card: Partial<CardMI>) {
  store.update(updateEntities(id, card));
}

export function deleteMI(id: CardMI['id']) {
  store.update(deleteEntities(id));
}

